import { render, staticRenderFns } from "./OrganizationPositionsTable.vue?vue&type=template&id=2dc81adf&scoped=true"
import script from "./OrganizationPositionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationPositionsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationPositionsTable.vue?vue&type=style&index=0&id=2dc81adf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc81adf",
  null
  
)

export default component.exports